import React, { useState, useEffect } from 'react';
import { IntlProvider, MessageFormatElement } from 'react-intl';
import useConfig from 'hooks/useConfig';
import { Roboto } from 'next/font/google';

const roboto = Roboto({ subsets: ['latin'], weight: ['300', '400', '500', '700', '900'] });

const loadLocaleData = (locale: string) => {
  switch (locale) {
    case 'en-US':
      return import('../../utils/locales/en.json');
    default:
      return import('../../utils/locales/tr.json');
  }
};

interface LocalsProps {
  children: React.ReactNode;
}

const Locales = ({ children }: LocalsProps) => {
  const { locale, onChangeFontFamily } = useConfig();
  const [messages, setMessages] = useState<Record<string, string> | Record<string, MessageFormatElement[]> | undefined>();

  useEffect(() => {
    loadLocaleData(locale).then((d: { default: Record<string, string> | Record<string, MessageFormatElement[]> | undefined }) => {
      setMessages(d.default);
    });
  }, [locale]);

  useEffect(() => {
    onChangeFontFamily(roboto.style.fontFamily);
  }, []);

  return (
    <>
      {messages && (
        <IntlProvider locale={locale} defaultLocale={process.env.NEXT_PUBLIC_DEFAULT_LANGUAGE} messages={messages}>
          {children}
        </IntlProvider>
      )}
    </>
  );
};

export default Locales;
